import { render, staticRenderFns } from "./campus.vue?vue&type=template&id=29e41d74&scoped=true&"
import script from "./campus.vue?vue&type=script&lang=js&"
export * from "./campus.vue?vue&type=script&lang=js&"
import style1 from "./campus.vue?vue&type=style&index=1&id=29e41d74&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29e41d74",
  null
  
)

export default component.exports